<template>
  <div id="news" class="con">
    <navheader></navheader>
    <fixheader></fixheader>
    <div class="our_news"></div>
    <div class="container">
      <div class="block" id="block">
        <div class="news">
          <el-row :gutter="50">
            <!-- <el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6" style="padding: 0 50px;">
              <div class="newstop">新闻分类</div>
              <div class="newstype">1231</div>
            </el-col> -->
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-divider content-position="left" style="margin-bottom: 20px;"><i class="el-icon-s-operation"
                  style="font-size: 22px;"><span style="margin-left: 15px;">最新动态</span></i></el-divider>
              <template>
                <el-table :data="tableData" style="width: 100%">
                  <el-table-column label="id" width="0">
                    <template slot-scope="scope">
                      <span>{{ scope.row.id }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="标题">
                    <template slot-scope="scope">
                      <i class="rudius"></i>
                      <el-link @click="toContent(scope.row.id,scope.row.weigh)" style="margin-left: 20px"
                        target="_blank" :underline="false">{{ scope.row.title }}</el-link>
                      <div v-if="scope.row.file" style="cursor: pointer;" @click="toContent(scope.row.id,scope.row.weigh)">
                        <el-row :gutter="50" style="align-items: center;">
                          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
                            <el-image :src="$http+scope.row.file" style="margin-top: 15px;width: 100%;"
                              fit="cover"></el-image>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
                            <div v-html="scope.row.content" class="news_content">{{scope.row.content}}</div>
                          </el-col>

                        </el-row>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="日期" width="100" style="text-align: right;">
                    <template slot-scope="scope">
                      <span>{{timestampToDate(scope.row.createtime) }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
              <el-pagination style="margin: 50px 0;" :current-page.sync="currentPage" background
                @current-change="handleCurrentChange" :page-size="30" layout="prev, pager, next" :total="total">
              </el-pagination>
            </el-col>

          </el-row>
        </div>
      </div>
    </div>
    <filing></filing>
  </div>
</template>

<script>
  import navheader from '@/components/Navheader.vue'
  import fixheader from '@/components/Fixheader.vue'
  import filing from '@/components/Filing.vue'
  export default {
    name: 'news',
    components: {
      navheader,
      fixheader,
      filing
    },
    data() {
      return {
        activeName: 'first',
        tableData: [],
        imageData: [],
        total: 0,
        currentPage: 1,
      };
    },
    beforeCreate() {

    },
    mounted: function() {
      this.$router.afterEach((to, from, next) => {
        window.scrollTo(0, 0)
      })
      this.currentPage = 1;
      this.getLimit(30);
    },
    methods: {
      handleClick(tab, event) {},
      toContent: function(mallCode, weigh) {
        this.$router.push({
          path: '/content',
          query: {
            number: mallCode,
            type: 1,
            weigh: weigh
          }
        })
      },
      getLimit(limit){
        this.axios.get(this.$http + "api/index/getCompanyNews", {
            params: {
              limit: limit,
              page: this.currentPage
            }
          })
          .then((res) => {
            console.log(res);
            this.total = res.data.data.total;
            this.tableData = res.data.data.data;
          })
          .catch((err) => {})
      },
      timestampToDate(timestamp) {
        if (timestamp.toString().length !== 10) {
          throw new Error('The timestamp should be a 10-digit integer.');
        }
        const date = new Date(timestamp * 1000); // 10位时间戳是秒级，需要乘以1000转换为毫秒
        return date.toISOString().slice(0, 10).replace('T', ' '); // 格式化为YYYY-MM-DD HH:MM:SS
      },
      setContextData: function(key, value) {
        if (typeof value == "string") {
          sessionStorage.setItem(key, value);
        } else {
          sessionStorage.setItem(key, JSON.stringify(value));
        }
      },
      getContextData: function(key) {
        const str = sessionStorage.getItem(key);
        if (typeof str == "string") {
          try {
            return JSON.parse(str);
          } catch (e) {
            return str;
          }
        }
        return;
      },
      handleCurrentChange: function(currentPage) {
        this.currentPage = currentPage;
        this.setContextData("currentPage", this.currentPage);
        this.getLimit(30)
      },
    }
  }
</script>

<style>
  #news .cell img {
    /* width: 100%;
    max-height: 100px; */
    border: 1px solid rgba(0, 0, 0, .3);
  }

  .el-table__row td:last-child {
    text-align: right;
  }

  .newstop {
    width: 100%;
    background-color: #409EFF;
    text-align: center;
    font-size: 22px;
    line-height: 46px;
    color: #ffffff;
  }

  .newstype {
    width: 100%;
    text-align: center;
    font-size: 18px;
    line-height: 46px;
    font-weight: normal !important;
    color: rgba(0, 0, 0, 0.6);
    border: 1px solid rgba(0, 0, 0, 0.2);
    cursor: pointer;
    transition: all 0.5s;
  }

  .news_content {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    align-items: center;
    margin-top: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/content/Our_news.vue